function initIngredientSplides(root) {
  var scope = root || document;

  if (typeof Splide === 'undefined') {
    console.warn('[ingredients-splide] Splide not loaded');
    return;
  }

  scope.querySelectorAll('[data-ingredients-splide]').forEach(function (el) {
    // Clean up old instance for editor reloads
    if (el.__splideInstance) {
      el.__splideInstance.destroy(true);
      el.__splideInstance = null;
    }

    var config = {};
    var cfg = el.getAttribute('data-splide');
    if (cfg) {
      try {
        config = JSON.parse(cfg);
      } catch (e) {
        console.warn('Invalid data-splide JSON', e);
      }
    }

    var splide = new Splide(el, config);
    splide.mount();
    el.__splideInstance = splide;
  });
}

// Loaded with `defer`, so DOM is ready:
initIngredientSplides();

// Shopify theme editor support
if (window.Shopify && Shopify.designMode) {
  document.addEventListener('shopify:section:load', function (event) {
    initIngredientSplides(event.target);
  });

  document.addEventListener('shopify:section:select', function (event) {
    initIngredientSplides(event.target);
  });

  document.addEventListener('shopify:block:select', function (event) {
    var root = event.target.closest('[data-ingredients-splide]');
    if (root) initIngredientSplides(root);
  });
}
